var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarknetLogo = function SvgStarknetLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "starknet-logo_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 251 251",
    style: {
      enableBackground: "new 0 0 251 251"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".starknet-logo_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fafafa}")), /*#__PURE__*/React.createElement("path", {
    d: "M251 125.5c0 69.3-56.2 125.5-125.5 125.5S0 194.8 0 125.5 56.2 0 125.5 0 251 56.2 251 125.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#29296e"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "starknet-logo_svg__st1",
    d: "m184.3 92-3.2-9.8c-.6-2-2.2-3.5-4.2-4.2l-9.8-3c-1.4-.4-1.4-2.3 0-2.8l9.8-3.2c2-.6 3.5-2.2 4.2-4.2l3-9.8c.4-1.4 2.3-1.4 2.8 0l3.2 9.8c.6 2 2.2 3.5 4.2 4.2l9.8 3c1.4.4 1.4 2.3 0 2.8l-9.8 3.2c-2 .6-3.5 2.2-4.2 4.2l-3 9.8c-.5 1.3-2.4 1.3-2.8 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11 123.5c3-5.9 8.9-10.4 15.1-13.2 6.2-2.8 13-4.5 19.7-5 13.5-1.2 26.7 1 38.7 5 6.2 1.9 11.7 4.4 17.4 7 2.8 1.3 5.4 2.9 8.1 4.4l7.4 4.3c8.2 5 16.1 9.5 23.5 13 7.5 3.4 14.2 5.8 20.5 7 6.3 1.2 12.8 1.2 20.7-.6 7.9-1.8 16.7-5.7 26-10.6 9.3-5 18.9-11.1 29.8-17-1.1 12.4-4.6 24.1-10 35.4-5.6 11.1-13.4 22-24.7 30.8-11.1 8.9-26.4 15-41.9 16-15.6 1.1-30.3-2.4-42.9-7.6-12.6-5.3-23.6-12.2-33.2-19.8-2.7-2.1-4.1-3.3-6.1-5l-5.5-4.9c-3.7-2.9-7.3-6.4-11-9.3C55.3 147 48 140.8 40 135.5c-4-2.7-8.1-5.3-12.8-7.5-2.3-1.1-4.8-2.1-7.5-2.9-2.7-.9-5.4-1.4-8.7-1.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ff4f0a"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "starknet-logo_svg__st1",
    d: "M11 123.7C12.5 111 18.4 99.1 27.9 89c9.4-10 24.2-17.8 40.5-18.8 8.1-.5 16.3.4 23.8 2.4 7.5 2.1 14.5 5.1 20.9 8.7 3.2 1.8 6.1 3.8 9.1 5.7l7.9 6 12.3 9.7c8 6.3 15.6 12.2 22.6 17.1 7.1 4.9 13.1 8.4 18.9 10.5 5.7 2.3 12.9 2.8 22.5.4 4.7-1.1 9.7-3.1 15-5.3 5.2-2.2 10.7-4.9 16.7-7.5-.7 6.4-2 12.7-4.5 18.7-2.4 6-5.5 11.9-9.8 17.4-2.2 2.7-4.6 5.4-7.4 7.8-2.8 2.4-5.9 4.7-9.3 6.7-6.8 3.9-14.9 6.8-23.2 7.9-8.3 1-16.6.5-24.2-1.1-7.6-1.6-14.5-4.1-20.9-7-12.7-5.9-23.3-13.3-32.7-21.2-4.7-3.9-9.1-8-13.3-12.2l-4.9-5c-1.5-1.4-3-2.9-4.5-4.2-6-5.3-11.6-9.4-17.7-11.9-6.1-2.7-13.9-3.7-23.5-1.9-9.6 1.9-20 6-31.2 11.8zM62 189c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "starknet-logo_svg__st1",
    d: "M62 189c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7z"
  })));
};
export default SvgStarknetLogo;